var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4338 4.79713L6.80013 2.02865L8.16646 4.79713C8.34853 5.16606 8.70049 5.42177 9.10763 5.48093L12.1628 5.92487L9.95206 8.07983C9.65746 8.367 9.52302 8.78075 9.59257 9.18625L10.1145 12.2291L7.38181 10.7925C7.01765 10.601 6.58261 10.601 6.21845 10.7925L3.4858 12.2291L4.00769 9.18625C4.07724 8.78075 3.94281 8.367 3.6482 8.07983L1.43744 5.92487L4.49263 5.48093C4.89977 5.42177 5.25173 5.16606 5.4338 4.79713ZM12.5256 5.57129L12.5253 5.57159L12.5256 5.57129ZM1.0747 5.57129C1.07479 5.57138 1.07488 5.57147 1.07497 5.57155L1.0747 5.57129Z",
    fill: "#025F4C",
    stroke: "#025F4C",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.55fe01076c0312a05472dab4548acd16.svg";
export { ForwardRef as ReactComponent };